export default __webpack_public_path__ + "static/media/foto_oben_mobile.4f0a7030.jpg";